module.exports = __webpack_public_path__ + "img/mxjs.11592b39.jpg";